import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';

import { CustomButtonsModule } from '@shared/buttons';
import { ContentSplitterModule } from '@shared/content-splitter';
import { LoadingIndicatorModule } from '@shared/loading-indicator';
import { ConfirmDialogModule } from '@shared/confirm-dialog';
import { ViewerComponent } from './viewer.component';
import { UndoRedoService } from './custom-tools/undo-redo.service';
// import { CornerstoneService } from './cornerstone.service';
import { ViewerService } from './viewer.service';
import { SegmentationService } from './custom-tools/segmentation/segmentation.service';
import { OCCViewerModule } from './occ-viewer/occ-viewer.module';
import { ResetViewsToolModule } from './custom-tools/reset-views-tool/reset-views-tool.module';
import { ImageSliderModule } from './image-slider/image-slider.module';
import { ColorsMenuModule } from './colors-menu/colors-menu.module';
import { ContextMenuModule } from '../context-menu/context-menu.module';
import { UpdateIndicatorModule } from '@shared/update-indicator/update-indicator.module';
import {
  ReferenceLineService,
  DataRequestService,
  PixelDataTransformationService,
  ProjectActionsRequestService,
  TimeTrackerService,
} from './services';
import { AlertDialogModule } from '@shared/alert-dialog';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    CustomButtonsModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    TranslateModule,
    OCCViewerModule,
    MatRadioModule,
    FormsModule,
    ContentSplitterModule,
    LoadingIndicatorModule,
    MatDividerModule,
    ResetViewsToolModule,
    ImageSliderModule,
    ColorsMenuModule,
    ContextMenuModule,
    UpdateIndicatorModule,
    ConfirmDialogModule,
    AlertDialogModule,
    MatTooltipModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [ViewerComponent],
  exports: [ViewerComponent],
  providers: [
    // CornerstoneService,
    ViewerService,
    UndoRedoService,
    SegmentationService,
    ReferenceLineService,
    DataRequestService,
    ProjectActionsRequestService,
    TimeTrackerService,
    PixelDataTransformationService,
  ],
})
export class ViewerModule {}
